import './secureLabel.scss';

export const SecureLabel = angular
    .module('checkout.components.secureLabel', [])
    .component('secureLabel', {
        template: `
            <div class="secure-label" layout="row" layout-align="center center">
                <div>
                    <md-icon>lock</md-icon>
                    <span>Safe &amp; secure checkout</span>
                </div>
            </div>
        `
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/secureLabel/secureLabel.js